/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line
$('.slick_slider_single').slick({
  dots: true,
  arrows: false,
  infinite: true,
  slidesToShow: 1
});
let i = 00;
/*sub collection js start**/ 
   function fetchCollectionItems(handle) {
        $.ajax({
            url: '/collections/' + handle,
            method: 'GET',
            success: function(response) {
        
                 var $response = $('<div>').html(response);
                var newItems = $response.find('#collection-items-container').html();
                $('#collection-items-container').html(newItems);

              if(!$('.header__mobile').is(':visible'))
              {
              
              }else{
                $('#collection-items-container').find('.collection__sidebar__slider').removeClass("no-mobile-animation");
              $('#collection-items-container').find('.collection__sidebar__slider').removeClass("expanded");
              }
                            
              
               
               var newTitle = $response.find('.collection__title .hero__title').html();
                $('.collection__title .hero__title').html(newTitle);

                var newDescription = $response.find('.collection__title .hero__description').html();
                  if (!newDescription) {
                    newDescription = ''; 
                  }
                  $('.collection__title .hero__description').html(newDescription);
               initializeFilterDrawer( $response);
            },
            error: function() {
                alert('Failed to load collection items.');
            }
        });
    }
 function initializeFilterDrawer(  $response ) {
   
   if(i==0){
     console.log("yes",i)
    i++;
     // $(document).off('click', '.popout__toggle, [data-collection-sidebar-close]');
    $(document).on('click', '.popout__toggle--filters', function() {
        console.log("i");
        var $button = $(this);
        var $drawer = $('#' + $button.attr('aria-controls'));
        $drawer.toggleClass('expanded');
        var expanded = $drawer.hasClass('expanded');
        $button.attr('aria-expanded', expanded);
    });
   
   }
    $(document).on('click', '[data-collection-sidebar-close]', function() {
      console.log("asdasdasd");
        var $drawer = $(this).closest('.collection__sidebar__slider');
        $drawer.removeClass('expanded');
        $('[aria-controls="' + $drawer.attr('id') + '"]').attr('aria-expanded', false);
    });
 } 
 
  $(document).on('click', '.slider_img_content_bottom a.subcollection_link', function(e) {
        e.preventDefault(); 
        var collectionHandle = $(this).data('collection-handle');
        fetchCollectionItems(collectionHandle);
    });

/*sub collection js end*/

  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
 